import { render, staticRenderFns } from "./pickups_reporte.vue?vue&type=template&id=afd2b172&scoped=true"
import script from "./pickups_reporte.vue?vue&type=script&lang=js"
export * from "./pickups_reporte.vue?vue&type=script&lang=js"
import style0 from "./pickups_reporte.vue?vue&type=style&index=0&id=afd2b172&prod&scoped=true&lang=css"
import style1 from "./pickups_reporte.vue?vue&type=style&index=1&id=afd2b172&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd2b172",
  null
  
)

export default component.exports